/**
 * SecureRoute Component
 * 
 * A wrapper component that protects routes requiring authentication.
 * Redirects to login if user is not authenticated.
 */

import React from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { Navigate } from 'react-router-dom';

const SecureRoute = ({ children }) => {
  const { authState, oktaAuth } = useOktaAuth();

  // Show loading while checking authentication
  if (!authState || authState.isPending) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
        color: 'white'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{
            width: '60px',
            height: '60px',
            border: '4px solid rgba(255, 255, 255, 0.2)',
            borderTopColor: '#dc3545',
            borderRadius: '50%',
            margin: '0 auto 20px',
            animation: 'spin 1s linear infinite'
          }}></div>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!authState.isAuthenticated) {
    // Save the current location to redirect back after login
    oktaAuth.setOriginalUri(window.location.pathname);
    return <Navigate to="/login" replace />;
  }

  // Render the protected content
  return children;
};

export default SecureRoute;
